module.exports = __webpack_public_path__ + "static/media/nebl.2ccea441.svg";